import { useTranslation } from "react-i18next";
import IlusEnReKYB from "src/assets/images/verification/ilus-re-kyb-en.webp";
import IlusIdReKYB from "src/assets/images/verification/ilus-re-kyb-id.webp";
import Button from "src/components-v2/Button";
import Modal from "src/components-v2/Modal";
import { COMPANY_TYPES } from "src/scenes/NewVerification/consts/company";

export default function ReKYBModal({ formBusiness, ownerEmail, onClose, show }) {
  const { t, i18n } = useTranslation("home");
  const legalEntityDocs = [
    "ktp",
    "npwp",
    "deed-of-establishment",
    "articles-of-association",
    "deed-of-latest-board",
    "sk-kemenkumham",
    "nib",
    "siup",
    "link"
  ];
  const individualDocs = ["ktp", "selfie"];
  const showDocs = formBusiness === COMPANY_TYPES.INDIVIDUAL ? individualDocs : legalEntityDocs;

  return (
    <Modal withoutCloseButton withoutHeader show={show}>
      <img src={i18n.language === "en" ? IlusEnReKYB : IlusIdReKYB} alt="re kyb" className="u-w-full u-mb-6" />
      <div className="u-mb-6">
        <p className="u-font-bold u-mb-2 u-text-medium">{t("re-kyb.modal.step-1.title")}</p>
        <ul>
          {showDocs.map((item, index) => (
            <li key={index}>{t(`re-kyb.modal.step-1.content.${item}`)}</li>
          ))}
        </ul>
        <p className="u-font-bold u-mb-2 u-text-medium">{t("re-kyb.modal.step-2.title")}</p>
        <p className="u-text-base u-mb-0">{t("re-kyb.modal.step-2.content", { email: ownerEmail })}</p>
      </div>
      <div className="u-text-right">
        <Button variant="secondary" color="orange" onClick={onClose}>
          {t("re-kyb.modal.button-ok")}
        </Button>
      </div>
    </Modal>
  );
}
